import React, {  useEffect, useState } from 'react';
import { Button, Divider, Skeleton, Space, Tree,Drawer,message,Modal } from 'antd';
import { DownOutlined,ExclamationCircleOutlined } from '@ant-design/icons';
import Helper from '../../func.js';
import XnodeEditor from './Editor.jsx';
import BrowserAccess from "./BrowserAccess";
import MoveNode from './Move';
import './List.css';
const { confirm } = Modal;
const {http} =Helper;
const service=(p)=>{
    return Helper.serviceUrl('node/'+p)
}

/**
 *
 * @param {{int}} props.projectId
 * @returns {JSX.Element|string}
 * @constructor
 */
const XnodeList= (props)=>{

    const [treeData,setTreeData] = useState([]);
    const [loading,setLoading] = useState(true);
    const [editing,setEditing] = useState(0);
    const [create,setCreateStatus] = useState(false);
    const [selectedNode,setSelectedNode] = useState('');
    const [isShowAccesBrowser,setAccesBrowser] = useState(false);
    const [moving,setMoving] = useState(null);
    const [checkedNodes,setCheckedNodes] = useState([]);
    const [batchMoving,setBatchMoving] = useState(null);
    const [cfg,setCfg]=useState({/*expandedKeys:null,*/defaultExpandAll:false})
    

    
    const getSelNodeId=()=>{return  selectedNode;}
    const hasSel=()=>{return !!selectedNode;}

    const onSelect = (selectedKeys, info) => {
      //console.log(selectedKeys)
      //console.log(info)
      setSelectedNode(selectedKeys[0]);
    };
    const onExpand=(expandedKeys)=>{
      setCfg({...cfg,...{expandedKeys:expandedKeys}})
    }
    const onRemove= ()=>{
      if(hasSel()){
        confirm({
          title: '确认移除吗',
          icon: <ExclamationCircleOutlined />,
          content: '移除节点后，不可恢复，请谨慎操作',
          okText: '移除',
          cancelText: '取消',
          okType: 'danger',
          onOk() {
            http.get(service('remove'),{node_id:getSelNodeId()||0},function(res){
              //setTreeData(res.result)
              message.success('已移除')
              setLoading(false)
              refresh();
            });
          }
        });
        
      }else{
        message.error('选择有误');
      }
    }

    const onEdit=()=>{
      if(hasSel()){ setEditing(selectedNode)}
      else message.error('选择有误');
    }

    const findNode = (items, id) => {
        for (const item of items) {
            if (Number(item.node_id) === Number(id)) return item;
            const found = findNode(item.children || [], id);
            if (found) return found;
        }
        return null;
    };

    const onMove = () => {
        const node = hasSel() && findNode(treeData, selectedNode);
        if (node) setMoving(node);
        else message.error('请先选择要移动的节点');
    };

    const afterMove = (parentId) => {
        const parent = findNode(treeData, parentId);
        const ancestors = (parent?.id_path || '').split('/').filter(Boolean).map(Number);
        setCfg({...cfg, expandedKeys: [...new Set([...(cfg.expandedKeys || [0]), 0, ...ancestors])]});
        setMoving(null);
        setBatchMoving(null);
        setCheckedNodes([]);
        refresh();
    };

    const onBatchMove = () => {
        const nodes = checkedNodes.map((id) => findNode(treeData, id)).filter(Boolean);
        if (!nodes.length || nodes.length !== checkedNodes.length) {
            message.error('请重新勾选要移动的节点');
            return;
        }
        setBatchMoving(nodes);
    };

    const withCheckboxes = (items) => items.map((item) => ({
        ...item, disableCheckbox: Number(item.node_id) === 0,
        children: item.children ? withCheckboxes(item.children) : undefined,
    }));

    const onBrowseAcces=()=>{
        if(hasSel()){ setAccesBrowser(true)}
        else message.error('选择有误');
    }

    const onCloseEditor=()=>{
      setEditing(0)
    }
    const refresh=()=>{
        setLoading(true)
        if(!props.projectId) { return ;}
        http.get(service('tree'), {project_id: props.projectId}, function (res) {
            setTreeData(res.result)
            setLoading(false)

            setCreateStatus(false)
            setEditing(0)
        }, function (data, error) {
            console.error(error);
        });
    }

    useEffect(()=>{refresh();},[props.projectId])// eslint-disable-line
   
    if(!props.projectId)return ''
    return (
        <div className="xnode-list">
            <Skeleton type='list' statistic={false} loading={loading} active paragraph={{ rows: 15 }}>
                <div className="xnode-list-toolbar">
                    <Space wrap>
                        <Button onClick={onBrowseAcces}>权限</Button>
                        <Button onClick={()=>setCreateStatus(true)}>添加</Button>
                        <Button onClick={onEdit}>修改</Button>
                        <Button onClick={checkedNodes.length ? onBatchMove : onMove}
                            disabled={!checkedNodes.length && !hasSel()}>
                            {checkedNodes.length ? `批量移动（${checkedNodes.length}）` : '移动'}
                        </Button>
                        {!!checkedNodes.length && <Button onClick={()=>setCheckedNodes([])}>清空勾选</Button>}
                        <Button danger={true} onClick={onRemove}>移除</Button>
                    </Space>
                    <Divider />
                </div>
                <div className="xnode-list-scroll">
                    <p>勾选多个节点后，可批量移动到同一父节点。</p>
                    <Tree
                        showLine
                        checkable
                        checkStrictly
                        checkedKeys={checkedNodes}
                        onCheck={(keys)=>setCheckedNodes(keys.checked.filter((id)=>Number(id)>0))}
                        switcherIcon={<DownOutlined />}
                        selectedKeys={[selectedNode]}
                        //defaultSelectedKeys={selected}
                        defaultExpandedKeys={[0]}
                        onSelect={onSelect}
                        treeData={withCheckboxes(treeData)}
                        onExpand={onExpand}
                        {...cfg}
                    />
                </div>
            </Skeleton>
            {moving && <MoveNode node={moving} projectId={props.projectId} treeData={treeData}
                onCancel={()=>setMoving(null)} afterMove={afterMove} />}
            {batchMoving && <MoveNode nodes={batchMoving} projectId={props.projectId} treeData={treeData}
                onCancel={()=>setBatchMoving(null)} afterMove={afterMove} />}
            <Drawer title="修改节点" placement="right" onClose={onCloseEditor} visible={!!editing}>
                <XnodeEditor xnodeId={editing} afterSave={refresh} msgTopic={props.msgTopic||''} />
            </Drawer>
            <Drawer title="创建节点" placement="right" onClose={()=>setCreateStatus(false)} visible={create}>
                <XnodeEditor xnodeId="+" afterSave={refresh} defaultData={{node_parent_id:getSelNodeId(),project_id:props.projectId}} msgTopic={props.msgTopic||''} />
            </Drawer>
            <Drawer title="拥有该权限的对象" placement="right" onClose={()=>setAccesBrowser(false)} visible={isShowAccesBrowser}>
                <BrowserAccess xnodeId={selectedNode}></BrowserAccess>
            </Drawer>
        </div>
    )
}
export default XnodeList;
